import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
// import uk from 'vuetify/src/locale/uk.ts'

Vue.use(Vuetify);

export default new Vuetify({

});
